export default {
    bucket_list_type: [
        ["custom", "Custom"],
        ["country", "Country"],
        ["region", "Region"],
        ["city", "City"],
        ["place", "Place"],
    ],
    contact_topic: [
        ["data_access", "Data access"],
        ["deletion", "Deletion"],
        ["correction", "Correction"],
        ["other", "Other"],
    ],
    impression: [
        [0, "Forgotten"],
        [1, "Bad"],
        [2, "Ok"],
        [3, "Good"],
        [4, "Great"],
        [5, "Awesome"],
    ],
    priority: [
        ["low", "Low"],
        ["high", "High"],
    ],
    privacy: [
        ["personal", "Personal"],
        ["everyone", "Everyone"],
    ],
    schedule_preference: [
        ["plan", "Plan"],
        ["commit", "Commit"],
        ["avoid", "Avoid"],
    ],
    transport: [
        ["plane", "Plane"],
        ["train", "Train"],
        ["car", "Car"],
        ["rented-car", "Rented car"],
        ["bus", "Bus"],
        ["ship", "Ship"],
        ["ferry", "Ferry"],
        ["boat", "Boat"],
        ["minivan", "Minivan"],
        ["taxi", "Taxi"],
        ["bike", "Bike"],
        ["walking", "Walking"],
    ],
    travel_reason: [
        ["vacation", "Vacation"],
        ["workation", "Workation"],
        ["business", "Business"],
        ["work", "Work"],
        ["education", "Education"],
        ["cruising", "Cruising"],
        ["sailing", "Sailing"],
        ["scuba-diving", "Scuba diving"],
        ["hiking", "Hiking"],
        ["school-trip", "School trip"],
        ["festival", "Festival"],
        ["skiing", "Skiing"],
        ["tournament", "Tournament"],
        ["camping", "Camping"],
        ["honeymoon", "Honeymoon"],
        ["wedding", "Wedding"],
        ["friends-family", "Friends & family"],
        ["other", "Other"],
    ],
    import_job_status: [
        ["pending", "Pending"],
        ["processing", "Processing"],
        ["success", "Success"],
        ["fail", "Fail"],
        ["error", "Error"],
    ],
    import_job_type: [
        ["trips", "Trips"],
        ["bucket-lists", "Bucket lists"],
    ],
    invitation_status: [
        ["unread", "Unread"],
        ["pending", "Pending"],
        ["accepted", "Accepted"],
        ["declined", "Declined"],
    ],
    geo_level: [
        ["country", 1],
        ["region", 2],
        ["city", 3],
        ["place", 4],
    ],
    travel_style: [
        ["budget", "Budget"],
        ["mid-range", "Mid-range"],
        ["premium", "Premium"],
        ["luxury", "Luxury"],
    ],
    travel_duration: [
        ["1", "1"],
        ["2-4", "2-4"],
        ["5-8", "5-8"],
        ["9-15", "9-15"],
        ["16-23", "16-23"],
        ["24+", "24+"],
    ],
    travel_months: [
        ["jan-feb", "January\u2013February"],
        ["mar-apr", "March\u2013April"],
        ["may-jun", "May\u2013June"],
        ["jul-aug", "July\u2013August"],
        ["sep-oct", "September\u2013October"],
        ["nov-dec", "November\u2013December"],
    ],
    travel_pace: [
        ["relaxed", "Relaxed"],
        ["moderate", "Moderate"],
        ["active", "Active"],
        ["demanding", "Demanding"],
    ],
    travel_region: [
        ["europe", "Europe"],
        ["asia", "Asia"],
        ["africa", "Africa"],
        ["north-america", "North America"],
        ["south-america", "South America"],
        ["oceania", "Oceania"],
        ["mediterranean", "Mediterranean"],
        ["nordics-arctic", "Nordics & Arctic"],
        ["caucasus-central-asia", "Caucasus & Central Asia"],
        ["middle-east", "Middle East"],
        ["north-africa", "North Africa"],
        ["west-central-africa", "West & Central Africa"],
        ["east-southern-africa", "East & Southern Africa"],
        ["indian-ocean", "Indian Ocean"],
        ["southeast-asia", "Southeast Asia"],
        ["east-asia", "East Asia"],
        ["south-asia", "South Asia"],
        ["australia-new-zealand", "Australia & New Zealand"],
        ["pacific-islands", "Pacific Islands"],
        ["north-america-west-coast", "West Coast (NA)"],
        ["north-america-east-coast", "East Coast (NA)"],
        ["caribbean", "Caribbean"],
        ["central-america", "Central America"],
        ["andes-patagonia", "Andes & Patagonia"],
    ],
    travel_theme: [
        ["nature", "Nature"],
        ["wildlife", "Wildlife"],
        ["hiking", "Hiking"],
        ["beach", "Beach"],
        ["islands", "Islands"],
        ["culture", "Culture"],
        ["history", "History"],
        ["food", "Food"],
        ["cities", "Cities"],
        ["road-trip", "Road trip"],
        ["winter", "Winter"],
        ["adventure", "Adventure"],
        ["diving", "Diving"],
        ["cruising", "Cruising"],
        ["events", "Events"],
        ["workation", "Workation"],
    ],
    country: [
        ["AF", "Afghanistan"],
        ["AL", "Albania"],
        ["DZ", "Algeria"],
        ["AS", "American Samoa"],
        ["AD", "Andorra"],
        ["AO", "Angola"],
        ["AI", "Anguilla"],
        ["AQ", "Antarctica"],
        ["AG", "Antigua and Barbuda"],
        ["AR", "Argentina"],
        ["AM", "Armenia"],
        ["AW", "Aruba"],
        ["AU", "Australia"],
        ["AT", "Austria"],
        ["AZ", "Azerbaijan"],
        ["BS", "Bahamas"],
        ["BH", "Bahrain"],
        ["BD", "Bangladesh"],
        ["BB", "Barbados"],
        ["BY", "Belarus"],
        ["BE", "Belgium"],
        ["BZ", "Belize"],
        ["BJ", "Benin"],
        ["BM", "Bermuda"],
        ["BT", "Bhutan"],
        ["BO", "Bolivia"],
        ["BQ", "Bonaire, Sint Eustatius and Saba"],
        ["BA", "Bosnia and Herzegovina"],
        ["BW", "Botswana"],
        ["BV", "Bouvet Island"],
        ["BR", "Brazil"],
        ["IO", "British Indian Ocean Territory"],
        ["BN", "Brunei"],
        ["BG", "Bulgaria"],
        ["BF", "Burkina Faso"],
        ["BI", "Burundi"],
        ["KH", "Cambodia"],
        ["CM", "Cameroon"],
        ["CA", "Canada"],
        ["CV", "Cape Verde"],
        ["KY", "Cayman Islands"],
        ["CF", "Central African Republic"],
        ["TD", "Chad"],
        ["CL", "Chile"],
        ["CN", "China"],
        ["CX", "Christmas Island"],
        ["CC", "Cocos (Keeling) Islands"],
        ["CO", "Colombia"],
        ["KM", "Comoros"],
        ["CG", "Congo"],
        ["CD", "Congo"],
        ["CK", "Cook Islands"],
        ["CR", "Costa Rica"],
        ["CI", "Ivory Coast"],
        ["HR", "Croatia"],
        ["CU", "Cuba"],
        ["CW", "Cura\u00e7ao"],
        ["CY", "Cyprus"],
        ["CZ", "Czech Republic"],
        ["DK", "Denmark"],
        ["DJ", "Djibouti"],
        ["DM", "Dominica"],
        ["DO", "Dominican Republic"],
        ["EC", "Ecuador"],
        ["EG", "Egypt"],
        ["SV", "El Salvador"],
        ["GQ", "Equatorial Guinea"],
        ["ER", "Eritrea"],
        ["EE", "Estonia"],
        ["ET", "Ethiopia"],
        ["FK", "Falkland Islands (Malvinas)"],
        ["FO", "Faroe Islands"],
        ["FJ", "Fiji"],
        ["FI", "Finland"],
        ["FR", "France"],
        ["GF", "French Guiana"],
        ["PF", "French Polynesia"],
        ["TF", "French Southern Territories"],
        ["GA", "Gabon"],
        ["GM", "Gambia"],
        ["GE", "Georgia"],
        ["DE", "Germany"],
        ["GH", "Ghana"],
        ["GI", "Gibraltar"],
        ["GR", "Greece"],
        ["GL", "Greenland"],
        ["GD", "Grenada"],
        ["GP", "Guadeloupe"],
        ["GU", "Guam"],
        ["GT", "Guatemala"],
        ["GG", "Guernsey"],
        ["GN", "Guinea"],
        ["GW", "Guinea-Bissau"],
        ["GY", "Guyana"],
        ["HT", "Haiti"],
        ["HM", "Heard Island and McDonald Islands"],
        ["VA", "Vatican"],
        ["HN", "Honduras"],
        ["HK", "Hong Kong"],
        ["HU", "Hungary"],
        ["IS", "Iceland"],
        ["IN", "India"],
        ["ID", "Indonesia"],
        ["IR", "Iran"],
        ["IQ", "Iraq"],
        ["IE", "Ireland"],
        ["IM", "Isle of Man"],
        ["IL", "Israel"],
        ["IT", "Italy"],
        ["JM", "Jamaica"],
        ["JP", "Japan"],
        ["JE", "Jersey"],
        ["JO", "Jordan"],
        ["KZ", "Kazakhstan"],
        ["KE", "Kenya"],
        ["KI", "Kiribati"],
        ["KP", "North Korea"],
        ["KR", "South Korea"],
        ["KW", "Kuwait"],
        ["KG", "Kyrgyzstan"],
        ["LA", "Laos"],
        ["LV", "Latvia"],
        ["LB", "Lebanon"],
        ["LS", "Lesotho"],
        ["LR", "Liberia"],
        ["LY", "Libya"],
        ["LI", "Liechtenstein"],
        ["LT", "Lithuania"],
        ["LU", "Luxembourg"],
        ["MO", "Macao"],
        ["MK", "North Macedonia"],
        ["MG", "Madagascar"],
        ["MW", "Malawi"],
        ["MY", "Malaysia"],
        ["MV", "Maldives"],
        ["ML", "Mali"],
        ["MT", "Malta"],
        ["MH", "Marshall Islands"],
        ["MQ", "Martinique"],
        ["MR", "Mauritania"],
        ["MU", "Mauritius"],
        ["YT", "Mayotte"],
        ["MX", "Mexico"],
        ["FM", "Micronesia"],
        ["MD", "Moldova"],
        ["MC", "Monaco"],
        ["MN", "Mongolia"],
        ["ME", "Montenegro"],
        ["MS", "Montserrat"],
        ["MA", "Morocco"],
        ["MZ", "Mozambique"],
        ["MM", "Myanmar"],
        ["NA", "Namibia"],
        ["NR", "Nauru"],
        ["NP", "Nepal"],
        ["NL", "Netherlands"],
        ["AN", "Netherlands Antilles"],
        ["NC", "New Caledonia"],
        ["NZ", "New Zealand"],
        ["NI", "Nicaragua"],
        ["NE", "Niger"],
        ["NG", "Nigeria"],
        ["NU", "Niue"],
        ["NF", "Norfolk Island"],
        ["MP", "Northern Mariana Islands"],
        ["NO", "Norway"],
        ["OM", "Oman"],
        ["PK", "Pakistan"],
        ["PW", "Palau"],
        ["PS", "Palestinian Territory"],
        ["PA", "Panama"],
        ["PG", "Papua New Guinea"],
        ["PY", "Paraguay"],
        ["PE", "Peru"],
        ["PH", "Philippines"],
        ["PN", "Pitcairn"],
        ["PL", "Poland"],
        ["PT", "Portugal"],
        ["PR", "Puerto Rico"],
        ["QA", "Qatar"],
        ["RE", "R\u00e9union"],
        ["RO", "Romania"],
        ["RU", "Russia"],
        ["RW", "Rwanda"],
        ["BL", "Saint Barth\u00e9lemy"],
        ["SH", "Saint Helena"],
        ["KN", "Saint Kitts and Nevis"],
        ["LC", "Saint Lucia"],
        ["MF", "Saint Martin (French part)"],
        ["PM", "Saint Pierre and Miquelon"],
        ["VC", "Saint Vincent and the Grenadines"],
        ["WS", "Samoa"],
        ["SM", "San Marino"],
        ["ST", "Sao Tome and Principe"],
        ["SA", "Saudi Arabia"],
        ["SN", "Senegal"],
        ["RS", "Serbia"],
        ["SC", "Seychelles"],
        ["SL", "Sierra Leone"],
        ["SG", "Singapore"],
        ["SX", "Sint Maarten (Dutch part)"],
        ["SK", "Slovakia"],
        ["SI", "Slovenia"],
        ["SB", "Solomon Islands"],
        ["SO", "Somalia"],
        ["ZA", "South Africa"],
        ["GS", "South Georgia and the South Sandwich Islands"],
        ["SS", "South Sudan"],
        ["ES", "Spain"],
        ["LK", "Sri Lanka"],
        ["SD", "Sudan"],
        ["SR", "Suriname"],
        ["SJ", "Svalbard and Jan Mayen"],
        ["SZ", "Swaziland"],
        ["SE", "Sweden"],
        ["CH", "Switzerland"],
        ["SY", "Syrian Arab Republic"],
        ["TW", "Taiwan"],
        ["TJ", "Tajikistan"],
        ["TZ", "Tanzania"],
        ["TH", "Thailand"],
        ["TL", "Timor-Leste"],
        ["TG", "Togo"],
        ["TK", "Tokelau"],
        ["TO", "Tonga"],
        ["TT", "Trinidad and Tobago"],
        ["TN", "Tunisia"],
        ["TR", "Turkey"],
        ["TM", "Turkmenistan"],
        ["TC", "Turks and Caicos Islands"],
        ["TV", "Tuvalu"],
        ["UG", "Uganda"],
        ["UA", "Ukraine"],
        ["AE", "United Arab Emirates"],
        ["GB", "United Kingdom"],
        ["US", "United States"],
        ["UM", "United States Minor Outlying Islands"],
        ["UY", "Uruguay"],
        ["UZ", "Uzbekistan"],
        ["VU", "Vanuatu"],
        ["VE", "Venezuela"],
        ["VN", "Vietnam"],
        ["VG", "British Virgin Islands"],
        ["VI", "U.S. Virgin Islands"],
        ["WF", "Wallis and Futuna"],
        ["EH", "Western Sahara"],
        ["YE", "Yemen"],
        ["ZM", "Zambia"],
        ["ZW", "Zimbabwe"],
        ["AX", "\u00c5land Islands"],
        ["XK", "Kosovo"],
        ["XZ", "International"],
        ["", "Unknown"],
    ],
    continent: [
        ["AF", "Africa"],
        ["AN", "Antarctica"],
        ["AS", "Asia"],
        ["EU", "Europe"],
        ["NA", "North America"],
        ["OC", "Oceania"],
        ["SA", "South America"],
    ],
    world_region: [
        ["005", "South America", "SA"],
        ["010", "Antarctica", "AN"],
        ["011", "Western Africa", "AF"],
        ["013", "Central America", "NA"],
        ["014", "Eastern Africa", "AF"],
        ["015", "Northern Africa", "AF"],
        ["017", "Middle Africa", "AF"],
        ["018", "Southern Africa", "AF"],
        ["021", "Northern America", "NA"],
        ["029", "Caribbean", "NA"],
        ["030", "Eastern Asia", "AS"],
        ["034", "Southern Asia", "AS"],
        ["035", "South-eastern Asia", "AS"],
        ["039", "Southern Europe", "EU"],
        ["053", "Australia and New Zealand", "OC"],
        ["054", "Melanesia", "OC"],
        ["057", "Micronesia", "OC"],
        ["061", "Polynesia", "OC"],
        ["143", "Central Asia", "AS"],
        ["145", "Western Asia", "AS"],
        ["151", "Eastern Europe", "EU"],
        ["154", "Northern Europe", "EU"],
        ["155", "Western Europe", "EU"],
        ["830", "Channel Islands", "EU"],
    ],
    country_world_region: [
        ["AD", "039"],
        ["AE", "145"],
        ["AF", "034"],
        ["AG", "029"],
        ["AI", "029"],
        ["AL", "039"],
        ["AM", "145"],
        ["AN", "029"],
        ["AO", "017"],
        ["AQ", "010"],
        ["AR", "005"],
        ["AS", "061"],
        ["AT", "155"],
        ["AU", "053"],
        ["AW", "029"],
        ["AX", "154"],
        ["AZ", "145"],
        ["BA", "039"],
        ["BB", "029"],
        ["BD", "034"],
        ["BE", "155"],
        ["BF", "011"],
        ["BG", "151"],
        ["BH", "145"],
        ["BI", "014"],
        ["BJ", "011"],
        ["BL", "029"],
        ["BM", "021"],
        ["BN", "035"],
        ["BO", "005"],
        ["BQ", "029"],
        ["BR", "005"],
        ["BS", "029"],
        ["BT", "034"],
        ["BV", "005"],
        ["BW", "018"],
        ["BY", "151"],
        ["BZ", "013"],
        ["CA", "021"],
        ["CC", "053"],
        ["CD", "017"],
        ["CF", "017"],
        ["CG", "017"],
        ["CH", "155"],
        ["CI", "011"],
        ["CK", "061"],
        ["CL", "005"],
        ["CM", "017"],
        ["CN", "030"],
        ["CO", "005"],
        ["CR", "013"],
        ["CU", "029"],
        ["CV", "011"],
        ["CW", "029"],
        ["CX", "053"],
        ["CY", "145"],
        ["CZ", "151"],
        ["DE", "155"],
        ["DJ", "014"],
        ["DK", "154"],
        ["DM", "029"],
        ["DO", "029"],
        ["DZ", "015"],
        ["EC", "005"],
        ["EE", "154"],
        ["EG", "015"],
        ["EH", "015"],
        ["ER", "014"],
        ["ES", "039"],
        ["ET", "014"],
        ["FI", "154"],
        ["FJ", "054"],
        ["FK", "005"],
        ["FM", "057"],
        ["FO", "154"],
        ["FR", "155"],
        ["GA", "017"],
        ["GB", "154"],
        ["GD", "029"],
        ["GE", "145"],
        ["GF", "005"],
        ["GG", "830"],
        ["GH", "011"],
        ["GI", "039"],
        ["GL", "021"],
        ["GM", "011"],
        ["GN", "011"],
        ["GP", "029"],
        ["GQ", "017"],
        ["GR", "039"],
        ["GS", "005"],
        ["GT", "013"],
        ["GU", "057"],
        ["GW", "011"],
        ["GY", "005"],
        ["HK", "030"],
        ["HM", "053"],
        ["HN", "013"],
        ["HR", "039"],
        ["HT", "029"],
        ["HU", "151"],
        ["ID", "035"],
        ["IE", "154"],
        ["IL", "145"],
        ["IM", "154"],
        ["IN", "034"],
        ["IO", "014"],
        ["IQ", "145"],
        ["IR", "034"],
        ["IS", "154"],
        ["IT", "039"],
        ["JE", "830"],
        ["JM", "029"],
        ["JO", "145"],
        ["JP", "030"],
        ["KE", "014"],
        ["KG", "143"],
        ["KH", "035"],
        ["KI", "057"],
        ["KM", "014"],
        ["KN", "029"],
        ["KP", "030"],
        ["KR", "030"],
        ["KW", "145"],
        ["KY", "029"],
        ["KZ", "143"],
        ["LA", "035"],
        ["LB", "145"],
        ["LC", "029"],
        ["LI", "155"],
        ["LK", "034"],
        ["LR", "011"],
        ["LS", "018"],
        ["LT", "154"],
        ["LU", "155"],
        ["LV", "154"],
        ["LY", "015"],
        ["MA", "015"],
        ["MC", "155"],
        ["MD", "151"],
        ["ME", "039"],
        ["MF", "029"],
        ["MG", "014"],
        ["MH", "057"],
        ["MK", "039"],
        ["ML", "011"],
        ["MM", "035"],
        ["MN", "030"],
        ["MO", "030"],
        ["MP", "057"],
        ["MQ", "029"],
        ["MR", "011"],
        ["MS", "029"],
        ["MT", "039"],
        ["MU", "014"],
        ["MV", "034"],
        ["MW", "014"],
        ["MX", "013"],
        ["MY", "035"],
        ["MZ", "014"],
        ["NA", "018"],
        ["NC", "054"],
        ["NE", "011"],
        ["NF", "053"],
        ["NG", "011"],
        ["NI", "013"],
        ["NL", "155"],
        ["NO", "154"],
        ["NP", "034"],
        ["NR", "057"],
        ["NU", "061"],
        ["NZ", "053"],
        ["OM", "145"],
        ["PA", "013"],
        ["PE", "005"],
        ["PF", "061"],
        ["PG", "054"],
        ["PH", "035"],
        ["PK", "034"],
        ["PL", "151"],
        ["PM", "021"],
        ["PN", "061"],
        ["PR", "029"],
        ["PS", "145"],
        ["PT", "039"],
        ["PW", "057"],
        ["PY", "005"],
        ["QA", "145"],
        ["RE", "014"],
        ["RO", "151"],
        ["RS", "039"],
        ["RU", "151"],
        ["RW", "014"],
        ["SA", "145"],
        ["SB", "054"],
        ["SC", "014"],
        ["SD", "015"],
        ["SE", "154"],
        ["SG", "035"],
        ["SH", "011"],
        ["SI", "039"],
        ["SJ", "154"],
        ["SK", "151"],
        ["SL", "011"],
        ["SM", "039"],
        ["SN", "011"],
        ["SO", "014"],
        ["SR", "005"],
        ["SS", "014"],
        ["ST", "017"],
        ["SV", "013"],
        ["SX", "029"],
        ["SY", "145"],
        ["SZ", "018"],
        ["TC", "029"],
        ["TD", "017"],
        ["TF", "014"],
        ["TG", "011"],
        ["TH", "035"],
        ["TJ", "143"],
        ["TK", "061"],
        ["TL", "035"],
        ["TM", "143"],
        ["TN", "015"],
        ["TO", "061"],
        ["TR", "145"],
        ["TT", "029"],
        ["TV", "061"],
        ["TW", "030"],
        ["TZ", "014"],
        ["UA", "151"],
        ["UG", "014"],
        ["UM", "057"],
        ["US", "021"],
        ["UY", "005"],
        ["UZ", "143"],
        ["VA", "039"],
        ["VC", "029"],
        ["VE", "005"],
        ["VG", "029"],
        ["VI", "029"],
        ["VN", "035"],
        ["VU", "054"],
        ["WF", "061"],
        ["WS", "061"],
        ["XK", "039"],
        ["YE", "145"],
        ["YT", "014"],
        ["ZA", "018"],
        ["ZM", "014"],
        ["ZW", "014"],
    ],
};
